/* eslint-disable max-len */
import React from 'react';
import bgBridge from '../../static/images/section8-remerciements/remerciements.jpg';
import trace from '../../static/images/effects/trace.svg';

export const Section8Remerciements = () => (
  <section id="section8-remerciements" className="mb-0 md:mb-0">
    <div className="intro-content">
      <div className="intro-photo-left">
        <div className="img-container">
          <img src={bgBridge} alt="messages des enfants sur un mur" />
        </div>
      </div>
      <div className="intro-text-right p-2 text-base">
        <h2 className="text-3xl">Remerciements</h2>
        <p className="mt-4 text-left text-sm">
          Nous remercions tous·te·s les participant·e·s au projet, sans qui rien de tout ceci n’aurait été possible&nbsp;: les enfants, les jeunes facilitateur·rices (Fatoumata, Binta, Aissatou, Nyasha, Mariama, Teresa, Bruna, Andrea, Nick Arnaud), les artistes (Krump, Sarah Cheveau, Alison Morgan, Amandine Branders, Dan-T, Jo Malkez), les webdesigner/developer (les étudiantes d’Interface 3 et Loïc Truchot), les professionnel·le·s de l’accueil ainsi que ceux·celles qui ont contribué à faire de ce projet une réalité.
        </p>
        <p className="mt-4 text-right">
          Merci !
        </p>
      </div>
    </div>
    <img className="trace-jeu w-1/3 md:w-1/6 m-auto" src={trace} alt="trace" />
  </section>
);
